import type { JSX } from "react";
import { type ModalKeys } from "@/lib/store/modal";
import { ModalCropProfilePicture } from "./App/CropProfilePicture";
import { ModalDeleteAccount } from "./App/DeleteAccount";
import { ModalAppExplainer } from "./App/Explainer";
import { ModalPushNotificationsDenied } from "./App/PushNotificationsDenied";
import { ModalCoreValuesAccuracyDetailsExplainer } from "./CoreValues/Accuracy/AccuracyDetailsExplainer";
import { ModalCoreValuesCompileExplainer } from "./CoreValues/Compile/Explainer";
import { ModalCoreValuesCompileGeneral } from "./CoreValues/Compile/General";
import { ModalCoreValuesDetail } from "./CoreValues/Detail";
import { ModalCoreValuesAccuracyExplainer } from "./CoreValues/Details/AccuracyExplainer";
import { ModalCoreValuesExplainer } from "./CoreValues/Explainer";
import { ModalCoreValuesFinished } from "./CoreValues/Finished";
import { ModalCoreValuesPersonalizeCompleted } from "./CoreValues/Personalize/Completed";
import { ModalCoreValuesPersonalizeExplainer } from "./CoreValues/Personalize/Explainer";
import { ModalCoreValuesResummarize } from "./CoreValues/Resummarize";
import { ModalDevDeleteFriendcheck } from "./Dev/DeleteFriendcheck";
import { ModalFriendCheckAnalysisConfirm } from "./FriendCheck/Analysis/Confirm";
import { ModalFriendCheckAnalysisGenerate } from "./FriendCheck/Analysis/Generate";
import { ModalFriendCheckAnalysisView } from "./FriendCheck/Analysis/View";
import { ModalFriendCheckCompleted } from "./FriendCheck/Completed";
import { ModalFriendCheckExplainer } from "./FriendCheck/Explainer";
import { ModalImpolitic } from "./Integrations/Impolitic";
import { ModalPerfectDayConfirmDelete } from "./PerfectDay/ConfirmDelete";
import { ModalPerfectDayExplainer } from "./PerfectDay/Explainer";
import { ModalPerfectDayUpdate } from "./PerfectDay/Update";
import { ModalReflectionAnalysisGenerate } from "./Reflection/Analysis/Generate";
import { ModalReflectionAnalysisView } from "./Reflection/Analysis/View";
import { ModalReflectionCompleted } from "./Reflection/Completed";
import { ModalReflectionExplainerGeneral } from "./Reflection/Explainer/General";
import { ModalReflectionQuestionCompleted } from "./Reflection/Question/Completed";
import { ModalReflectionQuestionFirstAnswer } from "./Reflection/Question/FirstAnswer";

export function ModalProvider() {
	return (
		<>
			{Object.entries({
				appCropProfilePicture: ModalCropProfilePicture,
				appDeleteAccount: ModalDeleteAccount,
				appExplainer: ModalAppExplainer,
				appPushNotificationsDenied: ModalPushNotificationsDenied,
				coreValuesCompileExplainer: ModalCoreValuesCompileExplainer,
				coreValuesCompileGeneral: ModalCoreValuesCompileGeneral,
				coreValuesDetail: ModalCoreValuesDetail,
				coreValuesAccuracyExplainer: ModalCoreValuesAccuracyExplainer,
				coreValuesAccuracyDetailsExplainer: ModalCoreValuesAccuracyDetailsExplainer,
				coreValuesExplainer: ModalCoreValuesExplainer,
				coreValuesPersonalizeCompleted: ModalCoreValuesPersonalizeCompleted,
				coreValuesPersonalizeExplainer: ModalCoreValuesPersonalizeExplainer,
				coreValuesResummarize: ModalCoreValuesResummarize,
				coreValuesFinished: ModalCoreValuesFinished,
				devDeleteFriendcheck: ModalDevDeleteFriendcheck,
				friendCheckAnalysisGenerate: ModalFriendCheckAnalysisGenerate,
				friendCheckAnalysisView: ModalFriendCheckAnalysisView,
				friendCheckCompleted: ModalFriendCheckCompleted,
				friendCheckExplainer: ModalFriendCheckExplainer,
				integrationsImpolitic: ModalImpolitic,
				reflectionAnalysisGenerate: ModalReflectionAnalysisGenerate,
				reflectionAnalysisView: ModalReflectionAnalysisView,
				reflectionCompleted: ModalReflectionCompleted,
				reflectionExplainerGeneral: ModalReflectionExplainerGeneral,
				reflectionQuestionCompleted: ModalReflectionQuestionCompleted,
				reflectionQuestionFirstAnswer: ModalReflectionQuestionFirstAnswer,
				perfectDayExplainer: ModalPerfectDayExplainer,
				perfectDayUpdate: ModalPerfectDayUpdate,
				perfectDayConfirmDelete: ModalPerfectDayConfirmDelete,
				friendCheckAnalysisConfirm: ModalFriendCheckAnalysisConfirm,
			} satisfies Record<ModalKeys, () => JSX.Element>).map(([key, Component]) => (
				<Component key={key} />
			))}
		</>
	);
}
